export default "__VITE_ASSET__DQUKyfR3__"